/**
 * useIsMobileOnly — is the current user restricted to the field/mobile shell?
 *
 * Now driven by the per-role `app_access` flag (card BnkVHTRg-Aih), resolved
 * server-side as the UNION of ALL the user's roles: `field_only` only when
 * every role is field-only; `both` if any role is `both`. Admins/dev-emails
 * always resolve to `both` server-side. Returns false while unauthenticated
 * or when the flag is absent (older session) — nobody is sequestered by
 * surprise.
 *
 * Used for the post-login shell routing decision (`LoginForm.tsx`) and the
 * field→office redirect guard (`routes.tsx` `RootLayoutWithUser`).
 */

import { useAppSelector } from '../lib/reduxHooks.js';
import { selectRole } from '../store/slices/auth.js';
import { isFieldOnly } from '../utils/roles.js';

export function useIsMobileOnly(): boolean {
  const role = useAppSelector(selectRole);
  return isFieldOnly(role);
}
